import moment from 'moment';

import { AccountConnectorServiceEnum } from '~/generated/graphql';

import MetricWithPastValueComparison from '../MetricWithPastValueComparison';
import { useQueryEnrichmentMetric } from '../useQueryEnrichmentMetric';

type EnrichmentMetricProps = {
  className?: string;
  displayName: string;
  externalType: AccountConnectorServiceEnum;
  loadingSkeletonWidth?: string;
  metricName: string;
  queryStartDate: moment.Moment;
};

function EnrichmentMetric({
  className,
  displayName,
  externalType,
  loadingSkeletonWidth,
  metricName,
  queryStartDate,
}: EnrichmentMetricProps) {
  const respData = useQueryEnrichmentMetric({
    queryStartDate: queryStartDate,
    queryEndDate: moment(),
    metricName: metricName,
    externalType: externalType,
  });

  return (
    <MetricWithPastValueComparison
      className={className}
      currentRangeLoading={respData?.currentRangeLoading}
      currentRangeValue={respData?.currentRangeData?.uniques || 0}
      displayName={displayName}
      loadingSkeletonWidth={loadingSkeletonWidth}
      pastRangeLoading={respData?.pastRangeLoading}
      pastRangeValue={respData?.pastRangeData?.uniques || 0}
    />
  );
}

export default EnrichmentMetric;
